import { redirect } from '@tanstack/react-router';

import { useAuthStore } from '@/stores/authStore';
import { usePreviewStore } from '@/stores/previewStore';
import type { UserRole } from '@/types/auth';

const NON_STUDENT_REDIRECTS: Partial<Record<UserRole, string>> = {
  super_admin: '/admin/problems',
  org_admin: '/org',
  trainer: '/trainer',
};

const PREVIEW_ROLES: UserRole[] = ['trainer', 'super_admin'];

export function requireStudent() {
  const { user } = useAuthStore.getState();
  if (!user) return;
  if (usePreviewStore.getState().active && PREVIEW_ROLES.includes(user.role)) return;
  const dest = NON_STUDENT_REDIRECTS[user.role];
  if (dest) throw redirect({ to: dest });
}
